module.exports = __webpack_public_path__ + "static/media/boon-edam.fc0de1c2.png";